<div *ngIf="isLoggedIn && !headerHide" [ngClass]="{'side-collapse' : collapseMenu$}">
    <div class="maintenance-container" *ngIf="isMaintenanceBanner">
  <div class="maintenance-content">
      <p direction="left"> {{maintenanceMessage}}</p>
    <button class="close-btn" (click)="closeMaintenance()">
 <svg
  width="24"
  height="24"
  viewBox="0 0 24 24"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
  aria-label="Close"
  style="color: #ffffff;"
>
  <line x1="18" y1="6" x2="6" y2="18" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
  <line x1="6" y1="6" x2="18" y2="18" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
</svg>
    </button>
  </div>
  </div>
  <nav class="sidebar">
      <div class="sidebar-links">
          <ul>
              <li  (click)="collapseMenu()">
                  <a >
                  <span>
                      <mat-icon  class="material-icons-outlined">menu</mat-icon>
                      <span class="link hide">{{'hide_menu' | translate}}</span>
                  </span>
              </a>
                  </li>
              <ng-container *ngFor="let menu of menuList; let i = index">
                <li class="sidebar-icon" [attr.data-component]="i+'-menu'"[ngClass]="{ 'disable': menu.isDisable, 'active': menu.index === navigateID}" *ngIf="check(menu)">
                    <a (click)="navigateMenu(menu); $event.stopPropagation()"  [matTooltip]="menu.title | translate" matTooltipPosition = 'after' [matTooltipDisabled]="collapseMenu$ ? false : true">
                        <span>
                          <mat-icon [svgIcon]="menu.icon" class="icon"></mat-icon>
                            <!-- <img *ngIf="menu.image !== ''"  [src]="menu.image" [ngClass]="{'isSampleRepoer': menu.title == 'AI Report'}"> -->
                            <span class="link hide">{{ menu.title | translate }}</span>
                        </span>
                    </a>

                </li>
              </ng-container>

            </ul>
        </div>
        <div class="sidebar-links bottom-links">
            <ul>

                <li *ngIf="langList > 1 && returnVal(currentLangID)" (click)="changeLang(currentLangID)" class="lang-bg" matTooltip="{{'User.language' | translate}}" matTooltipPosition = 'after'>
                    <span>
                        <mat-icon  class="material-icons-outlined"> language</mat-icon>
                        <span class="link hide" [ngClass]="currentLangID === 2 ? 'ar-family':'en-family'">{{currentLangID === 1 ? 'English' : 'عربي'}}</span>
                    </span>
                </li>
                <li class="help"  matTooltip="{{'getHelp' | translate}}" matTooltipPosition = 'after' [matTooltipDisabled]="collapseMenu$ ? false : true">
                    <span (click)="getHelp()">
                        <mat-icon> error_outline</mat-icon>
                        <span class="link hide">{{ 'getHelp' | translate }}</span>
                    </span>
                </li>
            </ul>
        </div>
    </nav>
</div>
